import { useStaticQuery, graphql } from 'gatsby';

const useGlobalOptions = () => {
  const data = useStaticQuery(graphql`
    query useGlobalOptionsQuery {
      sanityGlobalOptions {
        showCallButton
        customizeThankYouPageButton
        thankYouPageReturnButtonLabel
        thankYouPageReturnLink {
          slug {
            current
          }
        }
      }
    }
  `);

  return data.sanityGlobalOptions;
};

export { useGlobalOptions };
